<script>
import { api } from '../../../firebase'

export default {
  name: 'MobilizeV2CreateImageTemplate',
  data() {
    return {
      form: {
        data: {
          image: {
            file: null,
            dataUri: null,
            raw: null
          },
          name: null
        },
        submitState: {
          pending: false,
          done: false,
          error: null
        }
      }
    }
  },
  methods: {
    onChange(e) {
      const dataUrlReader = new FileReader()
      dataUrlReader.addEventListener('load', event => {
        this.form.data.image.dataUri = event.target.result
      })
      dataUrlReader.readAsDataURL(this.form.data.image.file)

      const textReader = new FileReader()
      textReader.addEventListener('load', event => {
        this.form.data.image.raw = event.target.result
      })
      textReader.readAsText(this.form.data.image.file, 'utf-8')
    },
    async submitForm() {
      this.form.submitState.pending = true
      this.form.submitState.done = false
      this.form.submitState.error = null
      try {
        const response = await api.imageTemplates.create({
          name: this.form.data.name,
          image: this.form.data.image.raw,
          enabled: true
        })
        this.form.submitState.done = true
        this.$toast.success('Image template created successfully')
        return response
      } catch (error) {
        this.form.submitState.error = error
        this.$toast.error('Image template creation failed')
      } finally {
        this.form.submitState.pending = false
      }
    },
    resetForm() {
      this.form = {
        submitState: {
          pending: false,
          done: false,
          error: null
        },
        data: {
          image: {
            file: null,
            dataUri: null,
            raw: null
          },
          name: null
        }
      }
    },
    async onCreateButtonClick() {
      const response = await this.submitForm()
      if (this.form.submitState.error) {
        return
      }
      const { id } = response
      this.$router.push(`/mobilizev2/image-templates/${id}`)
    },
    async onCreateAndAddAnotherButtonClick() {
      await this.submitForm()
      if (this.form.submitState.error) {
        return
      }
      this.resetForm()
    },
    async onResetButtonClick() {
      this.resetForm()
    }
  }
}
</script>

<template>
  <div class="mobilizev2-view">
    <h1>Create an Image Template</h1>
    <v-form>
      <v-text-field label="Name" placeholder="Name" :disabled="form.submitState.pending" v-model="form.data.name" />
      <v-file-input
        label="Image"
        placeholder="Image"
        hint="Must be an SVG file"
        :persistent-hint="true"
        accept=".svg"
        :disabled="form.submitState.pending"
        v-model="form.data.image.file"
        @change="onChange"
      />
      <div class="my-5">
        <img v-if="form.data.image.dataUri" class="block preview" :src="form.data.image.dataUri" />
        <div v-else class="preview placeholder"><p>Select a file</p></div>
      </div>
      <v-alert class="block" v-if="form.submitState.error">
        <p>{{ form.submitState.error.message }}</p>
      </v-alert>
      <div class="d-flex flex-row-reverse">
        <v-btn
          color="primary"
          class="mini-hidden mx-1 ml-0"
          :disabled="form.submitState.pending"
          @click="onCreateButtonClick"
        >
          <v-icon left dark>add</v-icon>
          Create
        </v-btn>
        <v-btn
          color="primary"
          class="mini-hidden mx-1"
          :disabled="form.submitState.pending"
          @click="onCreateAndAddAnotherButtonClick"
        >
          <v-icon left dark>add</v-icon>
          Create &amp; add another
        </v-btn>
        <v-btn
          color="light-grey"
          class="mini-hidden mx-1"
          :disabled="form.submitState.pending"
          @click="onResetButtonClick"
        >
          <v-icon left dark>undo</v-icon>
          Reset
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<style lang="scss" scoped>
.block {
  display: block;
}

.my-10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

.preview {
  max-height: 600px;
  max-width: 100%;
}

.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eee;
  width: 600px;
  height: 600px;
}
</style>
